import React, { useState } from 'react';
import logo from "../assetes/logo.png";
import { GrAppsRounded } from "react-icons/gr";
import { IoIosPeople } from "react-icons/io";
import { TbLogout } from "react-icons/tb";
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { FaBars, FaTimes } from "react-icons/fa"; // أيقونات القائمة والإغلاق

function Header() {
    const role = sessionStorage.getItem('role');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // حالة القائمة المتنقلة

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <div className="flex">
            {/* زر القائمة للجوال */}
            <div className="md:hidden fixed top-4 left-4 z-50">
                <button onClick={toggleMobileMenu} className="text-black text-2xl">
                    {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </div>

            {/* الشريط الجانبي */}
            <div
                className={`bg-gradient-to-b from-[#3a3a3a] to-[#1a1a1a] h-screen w-[250px] flex flex-col fixed md:relative transform ${
                    isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
                } md:translate-x-0 transition-transform duration-300 ease-in-out z-40`}
            >
                <div className="pt-4 flex items-center justify-center">
                    <img src={logo} alt="Logo" className="w-[150px]" />
                </div>
                <nav className="flex flex-col space-y-4 px-4 pt-[50px] pl-[45px]">
                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            `[rgb(255,140,10)] flex items-center transition-all font-[400] cursor-pointer ${
                                isActive ? "font-bold text-[rgb(255,140,10)]" : "text-[#FFF] hover:text-[#FFA500]"
                            }`
                        }
                        onClick={() => setIsMobileMenuOpen(false)} // إغلاق القائمة عند النقر
                    >
                        <GrAppsRounded className="text-[19px]" />
                        <span className="pl-[10px]">Aufträge</span>
                    </NavLink>
                    {role === "admin" && (
                        <NavLink
                            to="/partner"
                            className={({ isActive }) =>
                                `[rgb(255,140,10)] flex items-center transition-all font-[400] cursor-pointer ${
                                    isActive ? "font-bold text-[rgb(255,140,10)]" : "text-[#FFF] hover:text-[#FFA500]"
                                }`
                            }
                            onClick={() => setIsMobileMenuOpen(false)} // إغلاق القائمة عند النقر
                        >
                            <IoIosPeople className="text-[20px]" />
                            <span className="pl-[10px]">Partner</span>
                        </NavLink>
                    )}
                    {role === "admin" && (
                        <NavLink
                            to="/admin"
                            className={({ isActive }) =>
                                `[rgb(255,140,10)] flex items-center transition-all font-[400] cursor-pointer ${
                                    isActive ? "font-bold text-[rgb(255,140,10)]" : "text-[#FFF] hover:text-[#FFA500]"
                                }`
                            } 
                            onClick={() => setIsMobileMenuOpen(false)} // إغلاق القائمة عند النقر
                        >
                            <MdOutlineAdminPanelSettings className="text-[20px]" />
                            <span className="pl-[10px]">Admin</span>
                        </NavLink>
                    )}
                </nav>
                <div className="pt-[250px]">
                    <div className="border-b-[2px] border-b-[rgb(138,138,138)] w-[80%] ml-[20px] flex justify-center"></div>
                    <div className="p-4 pl-[45px] pt-[70px]">
                        <div
                            onClick={() => {
                                sessionStorage.removeItem("token");
                                navigate("/login");
                            }}
                            className="text-white flex items-center cursor-pointer transition-all space-x-2 hover:text-red-500"
                        >
                            <TbLogout />
                            <span>Abmelden</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* طبقة خلفية للقائمة المتنقلة */}
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                ></div>
            )}
        </div>
    );
}

export default Header;